import styled from 'styled-components';

import { colors, typography } from '../../../../styles/tokens';

export const Panel = styled.div`
  margin-top: 56px;
  border-radius: 34px;
  border: 1px solid ${colors.border};
  background: ${colors.surfaceSunken};
  padding: 36px;
`;

export const Heading = styled.h3`
  font-family: ${typography.displayFontFamily};
  font-weight: 700;
  font-size: 26px;
  margin: 0;
  color: ${colors.textPrimary};
`;

export const Lead = styled.p`
  margin: 10px 0 28px;
  font-size: 16px;
  line-height: 1.6;
  color: ${colors.textSecondary};
`;

export const Form = styled.form`
  display: grid;
  gap: 16px;
`;

// Cada linha agrupa 2 campos relacionados (nome+perfil, email+telefone)
// -- só empilha em 1 coluna em telas bem estreitas, não faz o grid
// inteiro reorganizar os 4 campos numa ordem solta.
export const Row = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;

  @media (max-width: 560px) {
    grid-template-columns: 1fr;
  }
`;

export const Field = styled.label`
  display: grid;
  gap: 8px;

  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: ${colors.textFaint};

  input,
  select,
  textarea {
    padding: 13px 16px;
    border-radius: 12px;
    border: 1px solid ${colors.borderAccent};
    background: ${colors.surface};
    color: ${colors.textPrimary};
    font-family: inherit;
    font-size: 16px;
    font-weight: 500;
    letter-spacing: 0;

    &:focus {
      border-color: ${colors.primary};
      outline: none;
    }
  }

  textarea {
    resize: vertical;
  }
`;

export const Actions = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 18px;
  margin-top: 8px;
`;

export const SubmitButton = styled.button`
  padding: 15px 30px;
  border-radius: 999px;
  border: none;
  background: ${colors.primary};
  color: ${colors.onPrimary};
  font-family: ${typography.displayFontFamily};
  font-weight: 700;
  font-size: 15px;
  cursor: pointer;
  transition: background-color 0.2s;

  &:hover:not(:disabled) {
    background: ${colors.primaryHover};
  }

  &:disabled {
    opacity: 0.6;
    cursor: default;
  }
`;

export const ResponseNote = styled.span`
  font-size: 14px;
  color: ${colors.textFaintest};
  font-weight: 600;
`;

export const ErrorText = styled.p`
  margin: 0;
  font-size: 14px;
  color: ${colors.danger};
`;

export const SuccessBox = styled.div`
  border: 1px solid ${colors.borderAccent};
  background: ${colors.surfaceAccent};
  border-radius: 18px;
  padding: 32px;

  div {
    font-size: 14px;
    font-weight: 800;
    letter-spacing: 0.08em;
    color: ${colors.primary};
    text-transform: uppercase;
  }

  p {
    margin: 12px 0 0;
    font-size: 16px;
    line-height: 1.6;
    color: ${colors.textPrimary};
  }
`;
